// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../../factories/child-tab-view-model";
import TabPage from "./../../../factories/tab-page";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/sorting";
import AppTabController from "../../../services/app-tab-controller";

function RoleUserTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.PageSize.subscribe(function () {
        if (self.PageIndex() === 0) {
            self.RefreshGrid();
        }
        else {
            self.PageIndex(0);
        }
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.UserCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteRoleUser");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "RoleUserAdd":
                self.ShowRoleUserDialog();
                break;
            case "RoleUserEdit":
                if (self.SelectedUserRow() != null) {
                    self.ShowUserTab(self.SelectedUserRow());
                }
                break;
            case "RoleUserDelete":
                if (self.SelectedUserRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteRoleUser(self.SelectedUserRow().OpenData);
                        }
                    });
                }
                break;
        }
    };
    self.SelectedUserId = ko.observable();
    self.SelectedUser = ko.observable();
    self.SelectedUser.subscribe(function () {
        self.AddRoleUser(self.SelectedUserId(), self.Role.RoleId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/RoleTab/GetRoleUserCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedUserRow(null);
            self.TotalRows(0);
            self.UserCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.UserCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddRoleUser = function (userId, roleId) {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/RoleTab/AddRoleUser", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            userId: userId,
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteRoleUser = function (roleUserId) {
        return Bao.post("Uadm/RoleTab/DeleteRoleUser", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleUserId: roleUserId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowUserTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("Uadm/User");
            newTab.UrlData({
                id: item.UserId
            });
            newTab.ObjectId(item.UserId);
            AppTabController.AddTab(newTab);
        }
    };
    self.ShowRoleUserDialog = function () { };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedUserRow = ko.observable({});
    self.SelectedUserRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RoleUserEdit":
                case "RoleUserDelete":
                    button.Enabled(!(self.SelectedUserRow() == null));
                    break;
                case "RoleUserAdd":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("Uadm/RoleTab/ResetRoleUser", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("Uadm/RoleTab/SaveRoleUserCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("Uadm/RoleTab/CopyRoleUserCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
}
;
export default RoleUserTabModel;